const Translation = {
  error: "Une erreur inattendue s'est produite.",
  errorHeader: "Opération échouée",
  supplier: "Fournisseur",
  currency: "Devise",
  service: "service",
  designation: "Désignation",
  cost: "Coût",
  unitCost: "Coût unitaire",
  unitCosts: "Frais unitaires",
  costs: "Frais",
  TND: "TND",
  trip: "Voyage Organisé",
  umrah: "Omra",
  luggage: "Bagages",
  handLuggage: "Bagages à main",
  name: "Nom",
  description: "Description",
  flightDuration: "Durée du vol",
  class: "Class",
  totalPrice: "Prix Total",
  date: "Date",
  returnDate: "Date de retour",
  commission: "Commission",
  commissionB2B: "Commission B2B",
  departureDate: "Date de départ",
  price: "Prix",
  meal: "Repas",
  number: "Nombre",
  flightNumber: "Numéro de vol",
  countryDeparture: "Pays de départ",
  airport: "Aéroport",
  startingName: "Nom de départ",
  countryArrival: "Pays d'arrivée",
  arrivalName: "Nom d'arrivée",
  arrivalDate: "Date d'arrivée",
  day: "Jour",
  hotel: "Hôtel",
  descriptionPackageDefault:
    "Vivez une expérience spirituelle inoubliable avec notre package Umrah 'Voyage Spirituel de Luxe'. Ce package a été conçu pour vous offrir un confort optimal et une expérience enrichissante lors de votre pèlerinage.Réservez dès maintenant !Ne manquez pas cette opportunité de vivre votre Umrah dans le confort et la sérénité. Contactez-nous pour plus d'informations et pour réserver votre place.",
  firstDestination: "Première Destination",
  destination: "Destination",
  departureName: "Nom de départ",
  arrivalName: "Nom d'arrivée",
  longitude: "Longitude",
  latitude: "Latitude",
  categories:"Categories",
  chooseCategories:"Choisir des categories"
};

export default Translation;
